export enum UserFilesSections {
    LIST = 1,
    DETAIL = 2,
    ADD_FILE = 3
}